import {Box, Container} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import React from 'react'
import {createPortal} from 'react-dom'
import {useHeader} from '../../../hooks/use-header'
import useIntersectionObserver from '../../../hooks/use-intersection-observer'

const PlpSubnavigation = ({children, filtersRef}) => {
    const {headerWrapper} = useHeader()

    // detect when filters start to go out of view and display the sticky filters
    const hideStickyFilters =
        useIntersectionObserver(filtersRef, {
            useOnce: false,
            // the billion px bottom margin is to disable the observer from firing when the filters are bellow the fold
            rootMargin: '-1px 0px 1000000000px 0px',
            // needed to prevent round off error on edge when set to 1
            threshold: 0.98
        }) ?? true

    if (!headerWrapper) {
        return null
    }

    return createPortal(
        <Box boxShadow="bottom" display={hideStickyFilters ? 'none' : 'block'}>
            <Container layerStyle="page" variant="no-padding">
                {children}
            </Container>
        </Box>,
        headerWrapper
    )
}

PlpSubnavigation.propTypes = {
    children: PropTypes.any,
    filtersRef: PropTypes.object
}

export default PlpSubnavigation
